'use strict';

(function(global) {
  /**
   * Класс кнопки React-панели действий.
   *
   * @memberOf WebAccess.components.wrappers.toolBar
   * @class ReactToolBarButton
   * @extends WebAccess.components.wrappers.BaseReactPageElement
   * @since 5.6.0.1300
   */
  var ReactToolBarButton = global.components.wrappers.BaseReactPageElement.extend({

    /**
     * Конструктор.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#init
     * @param {object} buttonModel Модель React-элемента страницы.
     * @param {string} parentGroupName Имя родительской группы кнопок.
     * @fires BaseObject.EVENTS#CLASS_INIT
     */
    init: function (buttonModel, parentGroupName) {
      this._super(buttonModel);

      this.groupName = parentGroupName;

      // Установить доступность действий в соответствии с режимом доступности ЗЗУ
      if(this._model.enabledWhen) {
        this._isEnabledOnAttachmentSelected =
          Boolean(this._model.enabledWhen & JOB_ACTION_ENABLED_WHEN.IS_ENABLED_ON_ATTACHMENT_SELECTED);
        this._isEnabledOnAborted = Boolean(this._model.enabledWhen & JOB_ACTION_ENABLED_WHEN.IS_ENABLED_ON_ABORTED);
        this._isEnabledOnDone = Boolean(this._model.enabledWhen & JOB_ACTION_ENABLED_WHEN.IS_ENABLED_ON_DONE);
        this._isEnabledOnRunning = Boolean(this._model.enabledWhen & JOB_ACTION_ENABLED_WHEN.IS_ENABLED_ON_RUNNING);
      }
    },

    /**
     * Имя класса.
     *
     * @private
     * @property BaseReactPageElement#className
     * @override
     * @see BaseReactPageElement#className
     */
    className: 'ReactToolBarButton',

    /**
     * Имя родительской группы, к которой принадлежит кнопка на панели действий.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ReactToolBarButton#groupName
     */
    groupName: '',

    /**
     * Признак доступности действия, если в области вложений выделен хотя бы один элемент.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ReactToolBarButton#_isEnabledOnAttachmentSelected
     */
    _isEnabledOnAttachmentSelected: false,

    /**
     * Признак доступности действия, если ЗЗУ прекращено.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ReactToolBarButton#_isEnabledOnAborted
     */
    _isEnabledOnAborted: true,

    /**
     * Признак доступности действия, если ЗЗУ выполнено.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ReactToolBarButton#_isEnabledOnDone
     */
    _isEnabledOnDone: true,

    /**
     * Признак доступности действия, если ЗЗУ в работе.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ReactToolBarButton#_isEnabledOnRunning
     */
    _isEnabledOnRunning: true,

    /**
     * Форматирование модели.
     *
     * @private
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#_formatModel
     */
    _formatModel: function () {
      this._super();

      // Для того, чтобы при установке tooltip'ов не изменялся текст кнопки.
      this._model['caption'] = this._model['caption'] || this._model['hint'];
    },

    /**
     * Установить подсказку на основе состояния действия и значений свойств.
     *
     * @private
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_setActualHint
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
     */
    _setActualHint: function() {
      var me = this;
      if (!me.isEnabled() && me._model.disabledHint) {
        me.setTooltip(me._model.disabledHint);
      } else {
        if (me._model.hint) {
          me.setTooltip(me._model.hint);
        } else {
          me.setTooltip(me.getLabel());
        }
      }
    },

    /**
     * Изменить размер кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#convertTo
     * @param {BUTTON} buttonSize Размер кнопки.
     * @fires WebAccess.components.wrappers.toolBar.ReactToolBar.EVENT.CHANGE
     * @deprecated since 5.6. Use hideCaption or showCaption instead.
     */
    convertTo(buttonSize) {
      this._warnAboutDeprecatedMethod(arguments.callee.name);

      if(buttonSize === BUTTON.LARGE) {
        this.showCaption();
      } else {
        this.hideCaption();
      }
      this.fire(WebAccess.components.wrappers.toolBar.ReactToolBar.EVENT.CHANGE);
      
      return this;
    },

    /**
     * Получает наименование прикладного действия, связанного с кнопкой на панели действий.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getLinkedAction
     * @returns {string} Имя прикладного действия, если действие указано, иначе пустая строка.
     */
    getLinkedAction: function () {
      return this._model.linkedAction;
    },

    /**
     * Получает режим доступности кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getEnabledMode
     * @returns {ACTION_ENABLED_MODE} Режим доступности кнопки.
     */
    getEnabledMode() {
      return this._model.enabledMode;
    },

    /**
     * Получает режим доступности кнопки при выборе вложений.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getIsEnabledOnAttachnentSelected
     * @deprecated since 5.6. Use getIsEnabledOnAttachmentSelected instead.
     * @returns {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnAttachnentSelected() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this.getIsEnabledOnAttachmentSelected();
    },


    /**
     * Получить режим доступности кнопки, если в области вложений выделен хотя бы один элемент.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getIsEnabledOnAttachmentSelected
     * @returns {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnAttachmentSelected() {
      return this._isEnabledOnAttachmentSelected;
    },

    /**
     * Получает режим доступности кнопки для прекращенных задач и заданий.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getIsEnabledOnAborted
     * @returns {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnAborted() {
      return this._isEnabledOnAborted;
    },

    /**
     * Получает режим доступности кнопки для выполненных задач и заданий.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getIsEnabledOnDone
     * @return {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnDone() {
      return this._isEnabledOnDone;
    },

    /**
     * Получает режим доступности кнопки для задач и заданий в состоянии "В работе".
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getIsEnabledOnRunning
     * @return {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnRunning() {
      return this._isEnabledOnRunning;
    },

    /**
     * Получает родительскую группу кнопок.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#group
     * @returns {WebAccess.components.wrappers.toolBar.ReactToolBarGroup} Объект типа WebAccess.components.wrappers.toolBar.ReactToolBarGroup.
     * @deprecated since 5.6. Use getParentGroup instead.
     * @use WebAccess.components.wrappers.toolBar.ReactToolBarButton.getParentGroup
     */
    group() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this.getParentGroup();
    },

    /**
     * Получает родительскую группу кнопок.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getParentGroup
     * @returns {WebAccess.components.wrappers.toolBar.ReactToolBarGroup} Объект типа WebAccess.components.wrappers.toolBar.ReactToolBarGroup.
     */
    getParentGroup: function () {
      return global.current.toolBar.groups[this.groupName];
    },

    /**
     * Скрывает заголовок кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#hideCaption
     * @fires WebAccess.components.wrappers.toolBar.ReactToolBarButton.EVENT.CHANGE_CAPTION_VISIBILITY
     */
    hideCaption: function () {
      this._model.isCaptionVisible = false;
      this.fire(WebAccess.components.wrappers.toolBar.ReactToolBarButton.EVENT.CHANGE_CAPTION_VISIBILITY);
      return this;
    },

    /**
     * Признак отображения заголовка кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#isCaptionVisible
     * @returns {boolean} True, если заголовок отображается, иначе False.
     */
    isCaptionVisible: function () {
      return this._model.isCaptionVisible;
    },

    /**
     * Признак кнопки маленького размера.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#isSmall
     * @returns {boolean} True, если кнопка маленького размера, иначе False.
     * @deprecated since 5.6. Use isCaptionVisible instead.
     */
    isSmall() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return !this._model.isCaptionVisible;
    },

    /**
     * Устанавливает текст всплывающей подсказки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#setHints
     * @param {string} hint Текст всплывающей подсказки.
     * @param {string} disabledHint Текст всплывающей подсказки при недоступной кнопке.
     * @return {WebAccess.components.wrappers.toolBar.ReactToolBarButton} Объект типа WebAccess.components.wrappers.toolBar.ReactToolBarButton.
     */
    setHints: function (hint, disabledHint) {
      this._model.hint = hint;
      this._model.disabledHint = disabledHint;
      this._setActualHint();
      this.fire(WebAccess.components.wrappers.toolBar.ReactToolBar.EVENT.CHANGE);
    },

    /**
     * Отображает заголовок кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#showCaption
     * @fires WebAccess.components.wrappers.toolBar.ReactToolBarButton.EVENT.CHANGE_CAPTION_VISIBILITY
     */
    showCaption: function () {
      this._model.isCaptionVisible = true;
      this.fire(WebAccess.components.wrappers.toolBar.ReactToolBarButton.EVENT.CHANGE_CAPTION_VISIBILITY);
      return this;
    },

    /**
     * Устанавливает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#setLabel
     * @param {string} text Заголовок элемента страницы
     * @return {WebAccess.components.wrappers.toolBar.ReactToolBarButton} Объект типа ReactToolBarButton.
     * @fires BaseReactPageElement#change
     * @override
     * @see BaseReactPageElement#setLabel
     */
    setLabel: function (text) {
      this._model.caption = text;
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.CHANGE);
      return this;
    },

    /**
     * Получает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getLabel
     * @return {string} Заголовок элемента страницы.
     * @override
     * @see BaseReactPageElement#getLabel
     */
    getLabel: function () {
      return this._model.caption;
    },

    /**
     * Устанавливает всплывающую подсказку.
     *
     * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#setTooltip
     * @param {string} text Текст всплывающей подсказки
     * @return {WebAccess.components.wrappers.toolBar.ReactToolBarButton} Объект типа ReactToolBarButton.
     * @fires BaseReactPageElement#change
     * @override
     * @see BaseReactPageElement#setTooltip
     */
    setTooltip: function (text) {
      this._model.hint = text;
      this._model.tooltip = text;
      console.log(this._model);
      this.fire(WebAccess.components.wrappers.AbstractBasePageElement.EVENT.CHANGE);
      return this;
    },

    /**
    * Получает текст всплывающей подсказки.
    *
    * @method WebAccess.components.wrappers.toolBar.ReactToolBarButton#getTooltip
    * @return {string} Текст всплывающей подсказки.
    * @override
    * @see BaseReactPageElement#getTooltip
    */
    getTooltip: function () {
      return this._model.hint;
    },
  }, {
    EVENT: {
      // Событие, срабатывающее при изменении видимости заголовка кнопки.
      CHANGE_CAPTION_VISIBILITY: 'changeCaptionVisibility'
    }
  });

  global.components.wrappers.toolBar.ReactToolBarButton = ReactToolBarButton;
})(window.WebAccess);